import ProfileAvatar from "app/components/ProfileAvatar";
import { IMemberList } from "app/containers/Features/components/MemberSelection/types";
import { formatEffortShorthand } from "app/containers/Features/helper";
import { EffortEstimatedType } from "app/containers/Features/types";
import React, { FC } from "react";
import { dateFormatter } from "utils/helpers";

const AssigneeRow: FC<{
  data: EffortEstimatedType & { member?: IMemberList };
}> = ({ data }) => {
  // Variables
  const { member, effort } = data;
  const { date, hours, minutes } = effort;

  return (
    <div className="py-2.5 px-4 flex items-center justify-between">
      <div className="flex items-center gap-1.5">
        <ProfileAvatar
          name={member?.name || "Unknown"}
          avatar={member?.avatar}
          circleClassName="!size-5"
        />
        <div className="flex flex-col leading-none gap-[5px]">
          <span className="text-sm text-black leading-none">
            {member?.name || "Unknown"}
          </span>
          <span className="text-xs text-secondary leading-none">
            {member?.role}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2.5">
        <span className="text-sm text-secondary leading-none text-nowrap">
          {dateFormatter(date, "onlyDate")}
        </span>
        <span className="text-sm text-black leading-none">
          {formatEffortShorthand(hours, minutes)}
        </span>
      </div>
    </div>
  );
};

export default AssigneeRow;
